import { readerViewUrl } from './pathnameHelpers';

export default function isReaderViewUrl() {
  return readerViewUrl.test(window.location.pathname);
}
